import Menu from './Menu/Menu.component';
import Search from "./Search/Search.component";
import AboutUs from "./AboutUs/AboutUs.component";
import OurServices from "./OurServices/OurServices.component";
import Advisor from "./Advisor/Advisor.component.js";
import Announcement from "./Announcement/Announcement.component";

export {
  Menu,
  Search,
  AboutUs,
  OurServices,
  Advisor,
  Announcement
}
